import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Home as HomeIcon } from "lucide-react";
import { agent, navLinks } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#141210] text-[#d9cdb8]">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Brand */}
        <div className="md:col-span-1">
          <img
            src={agent.logo}
            alt="Kristy Russo, Realtor — Buy · Sell · Invest"
            className="h-16 w-auto mb-4"
          />
          <p className="mt-2 text-sm leading-relaxed text-[#b3a690]">
            {agent.tagline}. Casual-luxury service across the Texas Hill Country.
          </p>
        </div>

        {/* Explore */}
        <div>
          <h4 className="text-[#f4ebd9] text-sm tracking-luxury uppercase mb-5">
            Explore
          </h4>
          <ul className="space-y-3">
            {navLinks.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  className="text-sm text-[#b3a690] hover:text-gold transition-colors duration-300"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-[#f4ebd9] text-sm tracking-luxury uppercase mb-5">
            Get in Touch
          </h4>
          <ul className="space-y-4 text-sm">
            <li>
              <a
                href={agent.phoneHref}
                className="flex items-center gap-3 text-[#b3a690] hover:text-gold transition-colors"
              >
                <Phone className="w-4 h-4 text-gold shrink-0" /> {agent.phone}
              </a>
            </li>
            <li>
              <a
                href={agent.emailHref}
                className="flex items-center gap-3 text-[#b3a690] hover:text-gold transition-colors break-all"
              >
                <Mail className="w-4 h-4 text-gold shrink-0" /> {agent.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-[#b3a690]">
              <MapPin className="w-4 h-4 text-gold shrink-0 mt-0.5" />
              {agent.location}
            </li>
          </ul>
        </div>

        {/* CTA */}
        <div>
          <h4 className="text-[#f4ebd9] text-sm tracking-luxury uppercase mb-5">
            Ready When You Are
          </h4>
          <p className="text-sm text-[#b3a690] leading-relaxed mb-5">
            Been told "no" before? Let's find your yes.
          </p>
          <Link
            to="/apply-to-buy"
            className="inline-flex items-center gap-2 bg-[#d4af37] hover:bg-[#c19a2e] text-white text-xs tracking-luxury uppercase px-6 py-3 rounded-full transition-colors duration-300"
          >
            <HomeIcon className="w-4 h-4" /> Start Your Journey
          </Link>
        </div>
      </div>

      <div className="border-t border-[#2a241d]">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#8a7f6c]">
          <p>© {new Date().getFullYear()} Kristy Russo, Realtor · RE/MAX Corridor. All Rights Reserved.</p>
          <p>Each office independently owned & operated. Equal Housing Opportunity.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
